/**
 * Labels for system-uploaded CoC files (created_by === 6).
 * FedEx picture proof uses filenames like `{tn}_ppod.jpg` / `{tn}_ppoda.jpg`.
 * Signature / letter POD uses names containing `pod` (e.g. `{tn}_pod.pdf`).
 */
export function getSystemFileUploadLabel(
  fileName: string | null | undefined
): string | null {
  if (!fileName) return null;
  const lower = fileName.toLowerCase();
  // Match `{tn}_ppod.ext` / `{tn}_ppoda.ext`, or an explicit display name.
  if (
    /_ppoda?\.[^/]+$/.test(lower) ||
    lower.startsWith('delivery photo uploaded')
  ) {
    return 'Delivery Photo Uploaded';
  }
  if (lower.includes('pod')) {
    return 'POD Uploaded';
  }
  if (lower.includes('calibration')) {
    return `Tive calibration certificate: ${fileName.replace(
      '_calibration.pdf',
      '.pdf'
    )}`;
  }
  return null;
}
